import React from 'react';
import styled from 'styled-components';
import { Paragraph } from '@telia/styleguide';
import Heading from '../../modules/heading/Heading';

const ErrorPage: React.FC = () => {
  return (
    <Container>
      <HeadingContainer>
        <Heading tag={'h1'} text={'Kjøpet ble ikke gjennomført'} size={'l'} />
      </HeadingContainer>
      <StyledParagraph>
        Dessverre var det noe som feilet, og kjøpet ble ikke gjennomført. Kontakt kundeservice på tlf +47 924 05 050 for
        å fullføre.
      </StyledParagraph>
    </Container>
  );
};

export default ErrorPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledParagraph = styled(Paragraph)`
  text-align: center;
  max-width: 40rem;
  width: 100%;
`;
